import { useCallback } from "react";
import { AssembleTypography } from "src/components/AssembleTypography";
import { StyledBlockButton } from "../StyledBlockButton/StyledBlockButton";

const HEADER_4 = "header-four";

export type H4BlockProps = {
  editorState: Draft.EditorState;
  onClick: (headline: string) => void;
};

export const H4Block = (props: H4BlockProps): JSX.Element => {
  const { editorState, onClick } = props;

  const startKey = editorState.getSelection().getStartKey();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(startKey)
    .getType();
  const active = blockType === HEADER_4;

  const onClickHeadline = useCallback(() => {
    onClick(HEADER_4);
  }, [onClick]);

  return (
    <StyledBlockButton active={active} onClick={onClickHeadline}>
      <AssembleTypography style={{ fontSize: "22px", fontWeight: "bold" }}>
        H4
      </AssembleTypography>
    </StyledBlockButton>
  );
};
